export default {"src":"/_next/static/media/borrow.50984f53.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};